export class FindAllProjects {
  public static readonly type = '[Group/Projects/List] FindAllProjects';
}
